<div class="page-reader-component" #gridContainer>
    <div class="grid" [ngStyle]="gridStyles" #grid>
        <div *ngFor="let section of sections" class="section-container" [ngStyle]="section.styles">
            <!-- Use ngSwitch to create different elements based on section type -->
            <ng-container [ngSwitch]="section.type">

                <!-- Rectangle -->
                <div *ngSwitchCase="'rectangle'" #sectionElement
                    style="height: 100%; width: 100%; font-family:inherit;">
                    {{ section.textContent }}
                </div>

                <!-- Image -->
                <img *ngSwitchCase="'image'" #sectionElement style="height: 100%;width: 100%; font-family: inherit;" />

                <!-- Text -->
                <p *ngSwitchCase="'text'" #sectionElement style="height: 100%;width: 100%;font-family: inherit;">
                    {{ section.textContent }}
                </p>

                <!-- Arrow Section -->
                <svg *ngSwitchCase="'arrow'" #sectionElement [attr.viewBox]="section.viewboxValue"
                    style="height: 100%;width: 100%; font-family: inherit;" preserveAspectRatio="none">
                    <path [attr.d]="section.pathData" [attr.stroke]="section.strokeColor"
                        [attr.stroke-width]="section.strokeWidth" [attr.stroke-dasharray]="section.fillType"
                        fill="none">
                    </path>
                </svg>

                <!-- Textbox Section -->
                <div *ngSwitchCase="'textbox'" class="textbox-section" #sectionElement
                    style="height: 100%;width: 100%; font-family: inherit;">
                    <div *ngFor="let option of section.options; let i = index" class="textbox-input-container"
                        style="font-family: inherit;" [style.width]="getLabelWidth(option)">
                        <label *ngIf="option.showLabel" [for]="'txt-' + section.id + '-' + i"
                            style="font-family: inherit;">{{ option.label }}</label>
                        <input type="text" class="textbox-input" [id]="'txt-' + section.id + '-' + i"
                            (click)="onTextboxClick($event, section.id, i)" [(ngModel)]="option.userValue"
                            [ngClass]="getTextboxInputClass(section.id, i)"
                            style="width:calc(100% - 2px); font-family: inherit; border: 1px solid black;"
                            [style.textAlign]="option.textAlign"
                            (input)="onTextBoxChange(section.id, section.options, i, $event )" autocomplete="off"
                            autocorrect="off" spellcheck="false" [readOnly]="showCorrectAnswers">
                    </div>
                </div>

                <!-- Line Section -->
                <svg *ngSwitchCase="'line'" #sectionElement viewBox="0 0 100 100" style="height: 100%;width: 100%"
                    preserveAspectRatio="none" [style.transform]="'rotate(' + section.rotation + 'deg)'">
                    <line [attr.x1]="section.x1" [attr.y1]="section.y1" [attr.x2]="section.x2" [attr.y2]="section.y2"
                        [attr.stroke]="section.strokeColor" [attr.stroke-width]="section.strokeWidth"
                        [attr.stroke-dasharray]="section.fillType">
                    </line>
                </svg>

                <!-- Rich Text -->
                <div *ngSwitchCase="'richText'" #sectionElement style="height: 100%;width: 100%; font-family: inherit;">
                    {{ section.textContent }}
                </div>

                <!-- Option Section -->
                <div *ngSwitchCase="'option'" #sectionElement style="height: 100%;width: 100%; font-family: inherit;">
                    <div class="options-grid" style="font-family: inherit;">
                        <div *ngFor="let option of section.options; let i = index" class="option-container"
                            style="font-family: inherit;" [style.width]="getLabelWidth(option)">
                            <div class="checkbox-wrapper" (click)="onCheckboxClick($event, section.id, i)">
                                <!-- Native checkbox -->
                                <input type="checkbox" [id]="'opt-' + section.id + '-' + i" class="quiz-checkbox"
                                    style="font-family: inherit;" [checked]="option.isChecked"
                                    (change)="onOptionChange($event, section.id, i)" />

                                <!-- SVG Checkmark -->
                                <svg [style.visibility]="showCorrectAnswers && option.isChecked ? 'visible' : 'hidden'"
                                    class="checkbox-checkmark" [ngClass]="{
                                        'check-correct': (option.isCorrect) || (option.isOptional && option.isChecked),
                                        'check-incorrect': (option.isChecked && !option.isCorrect && !option.isOptional)
                                    }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 8 L6 11 L13 4" stroke="black" stroke-width="2" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <!-- Dummy overlay -->
                                <span [style.visibility]="showCorrectAnswers ? 'visible' : 'hidden'"
                                    class="checkbox-overlay" [ngClass]="{
                                    'ov-correct': (option.isCorrect) || (option.isOptional && option.isChecked),
                                    'ov-optional': option.isOptional && !option.isChecked,
                                    'ov-incorrect': (option.isChecked && !option.isCorrect && !option.isOptional) 
                                    || (!option.isChecked && option.isCorrect)
                                }">
                                </span>
                            </div>
                            <label *ngIf="option.showLabel" [for]="'opt-' + section.id + '-' + i"
                                style="font-family: inherit;">{{
                                option.label
                                }}</label>
                        </div>
                    </div>
                </div>

                <!-- Default (fallback) -->
                <div *ngSwitchDefault #sectionElement style="font-family: inherit;">
                    {{ section.textContent }}
                </div>
            </ng-container>
        </div>
    </div>
</div>